import PropTypes from 'prop-types';
import { REPORT_TYPES } from './constants';

export const reportMetric = PropTypes.shape({
  metricId: PropTypes.string.isRequired,
  displayLabel: PropTypes.string.isRequired,
  allowBreakdown: PropTypes.bool,
  breakdownSelected: PropTypes.bool,
});

export const reportMetrics = PropTypes.arrayOf(reportMetric);

export const reportDefinition = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf([REPORT_TYPES.LOCATION, REPORT_TYPES.BARBER]),
});
